export const PAGE_LAYOUT_STYLED_CONSTS = {
    MAX_WIDTH_TINY: 600,
    MAX_WIDTH_SMALL: 776,
    MAX_WIDTH_REGULAR: 850,
    MAX_WIDTH_MEDIUM: 888,
};
